import { makeStyles } from '@surveycake/rc';
import { keyframes } from 'emotion';

const scaleFadeOut = keyframes(`
	0% {
    transform: scale(1);
    opacity: 1;
	}
	100% {
    transform: scale(1.8);
    opacity: 0;
	}
`);

export const useStyles = makeStyles([
  [
    'radio',
    (theme, [checked, inverse, size]) => `
		position: relative;
		font-size: ${theme.typography.fontSize[size === 'medium' ? 'h5' : 'h6']}px;
		width: 1em;
		height: 1em;

		&, & * {
			box-sizing: border-box;
		}
	`
  ],
  [
    'dot',
    (theme, [checked, inverse, size, rippleAnimationDuration]) => [
      `
			position: absolute;
			top: 50%;
			left: 50%;
			width: calc(1rem - 8px);
			height: calc(1rem - 8px);
			border-radius: 100%;
			transform: translate(-50%, -50%) scale(${checked ? 1 : 0});
			transition-property: transform;
			transition-duration: ${rippleAnimationDuration}ms;
			transition-timing-function: cubic-bezier(.78, .14, .15, .86);
		`,
      !inverse &&
        `
			background-color: ${
        checked ? theme.survey.control.active : theme.color.text.white
      };
		`,
      inverse &&
        `
			background-color: ${theme.color.primary.default};
		`
    ]
  ],
  [
    'border',
    (theme, [checked, inverse]) => [
      `
			position: absolute;
			width: 100%;
			height: 100%;
			border-width: 2px;
			border-style: solid;
			border-radius: 100%;
			transition-property: border-color;
			transition-duration: 0.3s;
		`,
      !inverse &&
        `
			border-color: ${
        checked ? theme.survey.control.active : theme.survey.control.default
      };
		`,
      inverse &&
        `
			background-color: white;
			border-color: ${
        checked ? theme.color.primary.default : theme.survey.control.default
      };
		`
    ]
  ],
  [
    'borderAnimation',
    (theme, [checked, inverse, size, rippleAnimationDuration]) => `
		animation-duration: ${rippleAnimationDuration}ms;
		animation-iteration-count: 1;
		animation-name: ${scaleFadeOut};
		animation-timing-function: cubic-bezier(.78, .14, .15, .86);
		animation-fill-mode: forwards;
	`
  ]
]);
